// auth-redirect.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanMatch, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { ScApiService } from '@sc-ui';
import { Observable, of } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class AuthRedirectGuard implements CanActivate, CanActivateChild, CanMatch {
  constructor(private router: Router, private api: ScApiService) {}

  private handle(stateUrl: string, route?: ActivatedRouteSnapshot): boolean | UrlTree {
    const params = route?.queryParamMap;
    const t = params?.get('t') ?? null;
    const s = params?.get('s') ?? null;
    const u = params?.get('u') ?? null;
    const eMail = params?.get('eMail') ?? null;

    if (t) this.api.post('trace', { TraceId: t, ContactId: u ?? this.api.userId }).subscribe();

    if (stateUrl.startsWith('/login') || stateUrl.startsWith('/register')) return true;

    const current = this.router.parseUrl(stateUrl);
    ['u', 'eMail', 't', 's', 'target', 'access_code'].forEach(k => delete (current.queryParams as any)[k]);
    const target = this.router.serializeUrl(current);
    const accessCode = params?.get('access_code') ?? current.queryParams?.access_code ?? null;

    if (s) {
      return this.router.createUrlTree(['/register', s], {
        queryParams: { target }
      });
    }

    if (!this.api.isLoggedIn || (u && u !== this.api.userId) || (eMail && eMail !== this.api.userEMail)) {
      return this.router.createUrlTree(['/login'], {
        queryParams: { target, ...(eMail ? { eMail } : {}), ...(u ? { u } : {}), ...(accessCode ? { access_code: accessCode } : {}) }
      });
    }

    return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    return this.handle(state.url, route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    return this.handle(state.url, childRoute);
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    const path = '/' + segments.map(s => s.path).join('/');
    // No ActivatedRouteSnapshot here; rely on current URL including query
    const stateUrl = this.router.url || path;
    return this.handle(stateUrl);
  }
}
